import { FC } from 'react';
import { Handle, Position, NodeProps } from '@xyflow/react';
import { Box } from '@mantine/core';

// -----------------------------------------------------------------------------
interface RelationshipNodeProps extends NodeProps {
  onContextMenu?: (event: React.MouseEvent, nodeId: string) => void;
}

// -----------------------------------------------------------------------------
export const RelationshipNode: FC<RelationshipNodeProps> = ({
  isConnectable = true,
  id,
  onContextMenu,
}) => {
  // ---------------------------------------------------------------------------
  const handleContextMenu = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    if (onContextMenu && id) {
      onContextMenu(event, id);
    }
  };
  // ---------------------------------------------------------------------------
  const getRelationshipStyle = () => {
    // Simple black circle for all relationship nodes
    // The visual state will be rendered on the edges instead
    return {
      width: '12px',
      height: '12px',
      backgroundColor: 'var(--mantine-color-dark-9)',
      border: 'none',
      borderRadius: '50%',
      position: 'relative' as const,
    };
  };
  // ---------------------------------------------------------------------------
  return (
    <Box
      style={{
        ...getRelationshipStyle(),
        cursor: 'pointer',
      }}
      onContextMenu={handleContextMenu}
      title="Right-click to edit relationship"
    >
      {/* Handles for connections */}
      <Handle
        type="target"
        position={Position.Left}
        id="left"
        isConnectable={isConnectable}
        style={{ left: '4px', opacity: 0 }}
      />
      <Handle
        type="target"
        position={Position.Right}
        id="right"
        isConnectable={isConnectable}
        style={{ right: '4px', opacity: 0 }}
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id="bottom"
        isConnectable={isConnectable}
        style={{ opacity: 0 }}
      />
    </Box>
  );
};
